import { IZone, IZoneData, IZonesResponse } from "./zone.types";
import { Zone } from "./zone";

export const mockZonesData = (): IZoneData[] => [
  {
    id: 1,
    description: "Zona Norte",
  },
  {
    id: 2,
    description: "Zona Sur",
  },
];

export const mockZones = (data: IZoneData[] = mockZonesData()): IZone[] =>
  data.map((item) => new Zone(item));

export const mockZonesResponse = (data: IZoneData[] = mockZonesData()): IZonesResponse => ({
  zones: data,
});
